import {RestApiService} from '../../../rest-api.service';
import {Observable} from 'rxjs';
import {ApiV0Fibu} from '../api.v0.fibu';
import {FibuAccountCreateReq} from '../../../../contracts/v0/fibu/booking.contract';
import {FBookingAccountCategoryRes, FBookingAccountRes} from '../../../../contracts/v0/fibu/misc.contracts';
import {BaseCollectionModel, BaseRestEndpoint} from '@yasc/yasc-material-components';


export class ApiV0FibuAccounts extends BaseRestEndpoint<FBookingAccountRes, FibuAccountCreateReq> {


    constructor(v0: ApiV0Fibu, rest: RestApiService) {
        super(`${v0.segment}/accounts`, rest, FBookingAccountRes);
    }

    getBookingAccountsCategories(): Observable<BaseCollectionModel<FBookingAccountCategoryRes>> {
        return this.rest.get(
            `${this.segment}/categories`,
            FBookingAccountCategoryRes,
        );
    }
}
